module.exports = __webpack_public_path__ + "static/fonts/iconfont.25c05c7a.ttf";